export default __webpack_public_path__ + "static/media/ic_Flag_blue_48px.d6a64ec1.svg";